import { z } from "zod";

// Schema para usuário comercial
export const userCommercialSchema = z.object({
  id: z.string().uuid({ message: "ID do usuário inválido" }),
  commission_percentage: z
    .number()
    .min(0, { message: "Percentual deve ser maior ou igual a 0" })
    .max(100, { message: "Percentual deve ser menor ou igual a 100" }),
});

// Schema para organização parceira participante
export const partnerParticipantSchema = z.object({
  id: z.string().uuid({ message: "ID da organização inválido" }),
});

// Schema para hunter (usuário ou organização)
export const hunterSchema = z.object({
  id: z.string().uuid({ message: "ID do hunter inválido" }),
});

// Schema principal do formulário de projeto
export const projectFormSchema = z.object({
  name: z.string().min(1, { message: "Nome do projeto é obrigatório" }),
  type_client: z.enum(["affinity", "affiliate"], {
    errorMap: () => ({ message: "Tipo de cliente deve ser 'affinity' ou 'affiliate'" }),
  }),
  level_hierarchical: z
    .number()
    .int({ message: "Quantidade de níveis deve ser um número inteiro" })
    .min(1, { message: "Deve ter pelo menos 1 nível" })
    .max(5, { message: "Deve ter no máximo 5 níveis" })
    .optional(),
  user_commercials: z.array(userCommercialSchema).optional().default([]),
  partner_participants: z.array(partnerParticipantSchema).optional().default([]),
  hunters: z.array(hunterSchema).optional().default([]),
}).refine(
  (data) => {
    // Se for affiliate, level_hierarchical é obrigatório
    if (data.type_client === "affiliate" && !data.level_hierarchical) {
      return false;
    }
    return true;
  },
  {
    message: "Níveis são obrigatórios para projetos afiliados",
    path: ["level_hierarchical"],
  }
);

